export default __webpack_public_path__ + "images/8O.27b6cba.png";